module.exports = __webpack_public_path__ + "1505806eccecead34e26509339f4b5ac.MP3";